export default __webpack_public_path__ + "static/UDKU logo-826693d728989f2d28b342bb6e46d21c.png";